<template>
  <div class="page">
    <div class="page-header flex-shrink-0 shadow-sm p-3">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Property/Policy Details</h5>
        <router-link title="Edit Policy" :to="{ name: 'PropertyInsurancePolicies' }" class="btn btn-link">Back to
          properties</router-link>
      </div>
    </div>
    <div class="p-4 overflow-auto">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div class="row">
            <div class="col">
              <div class="card h-auto">
                <div class="card-header">
                  <h6 class="card-title mb-0"><i class="fa fa-building mr-1"></i>Property Information<b-spinner
                      class="ml-2" v-show="isBusy" small label="Small Spinner"></b-spinner></h6>
                </div>
                <!--Poperty Information-->
                <div class="card-body" v-if="details">
                  <div class="row">
                    <div class="col-md-6 col-12">Property Name (DBA)</div>
                    <div class="col-md-6 col-12">{{ details.name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">Legal Entity Name</div>
                    <div class="col-md-6 col-12">{{ details.legalEntityName }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">Street Address</div>
                    <div class="col-md-6 col-12">{{ details.streetAddress }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">Mailing Address</div>
                    <div class="col-md-6 col-12">{{ details.mailingAddress }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">City</div>
                    <div class="col-md-6 col-12">{{ details.city }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">State</div>
                    <div class="col-md-6 col-12">{{ details.state }}</div>
                  </div>
                  <!-- <div class="d-flex">
                    <div class="small w-50">County</div>
                    <div class="small w-50">{{ details.county }}</div>
                  </div>                                                 -->
                  <div class="row">
                    <div class="col-md-6 col-12">Zip Code</div>
                    <div class="col-md-6 col-12">{{ details.postalCode }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">Unit Count</div>
                    <div class="col-md-6 col-12">{{ details.unitCount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row mt-2 mb-2">
            <div class="col">
              <div class="card h-auto">
                <div class="card-header">
                  <h5 class="card-title"><i class="fa fa-id-card-o mr-1"></i>Agent Information</h5>
                </div>
                <div class="card-body">BODY</div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="col-md-8 col-sm-12">
          <div class="card h-auto">
            <div class="card-header py-1 pr-1">
              <div class="d-flex justify-content-between align-items-center">
                <h6 class="card-title mb-0"><i class="fa fa-file-signature mr-1"></i>Policy Information<b-spinner
                    class="ml-2" v-show="isBusy" small label="Small Spinner"></b-spinner></h6>
                <router-link title="Add Policy" :to="{ name: 'AddEditInsurancePolicy', 
                  query: { propertyId: this.propertyId }}" class="btn btn-success"><i class="fa fa-plus"></i> Add
                  Policy</router-link>
              </div>
            </div>
            <!--Policy Information-->
            <div class="card-body p-0" v-if="details" style="min-height:165px;max-height: 200px;">
              <div v-if="details.policies.length > 0" class="overflow-auto" style="border-top:0">
                <b-table :items="details.policies" :fields="policyFields">
                  <template v-slot:cell(assignmentReason)="data">
                    <div v-if="data.item.applyToAllProperties">
                      <b-badge variant="success" v-b-tooltip.hover title="This policy applies to all properties in the company">
                        <i class="fas fa-globe"></i> All Properties
                      </b-badge>
                    </div>
                    <div v-else-if="data.item.assignedViaPropertyGroup">
                      <b-badge variant="info" v-b-tooltip.hover :title="'This policy applies via property group: ' + (data.item.propertyGroupName || 'Unknown')">
                        <i class="fas fa-layer-group"></i> Via Group
                      </b-badge>
                    </div>
                    <div v-else>
                      <b-badge variant="primary" v-b-tooltip.hover title="This policy is directly assigned to this property">
                        <i class="fas fa-building"></i> Direct
                      </b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(startDate)="data">
                    <div>
                      {{ data.item.startDate | formatDateNoTime }}
                    </div>
                  </template>
                  <template v-slot:cell(endDate)="data">
                    <div :class="{ 'text-danger': data.item.expiringInDays <= 30 }">
                      {{ data.item.endDate | formatDateNoTime }}
                    </div>
                  </template>
                  <template v-slot:cell(premium)="data">
                    <div>
                      {{ data.item.premium | formatCurrency }}
                    </div>
                  </template>
                  <template v-slot:cell(premiumAnnualized)="data">
                    <div>
                      {{ data.item.premiumAnnualized | formatCurrency }}
                    </div>
                  </template>
                  <template v-slot:cell(coverageAmount)="data">
                    <div>
                      {{ data.item.coverageAmount | formatCurrency }}
                    </div>
                  </template>
                  <template v-slot:cell(deductible)="data">
                    <div>
                      {{ data.item.deductible | formatCurrency }}
                    </div>
                  </template>
                  <template v-slot:cell(id)="data">
                    <div>
                      <router-link title="Edit Policy"
                        :to="{ name: 'AddEditInsurancePolicy', params: { id: data.item.id }, query: { propertyId: details.propertyId }}"
                        class="btn btn-link"><i class="fa fa-pencil"></i></router-link>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="no-results d-flex justify-content-center align-items-center p-4 text-black-50 mx-4"
                v-if="details.policies.length == 0">No policies</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <div class="card">
            <!--Policy Statement of values-->
            <div class="card-header">
              <h6 class="card-title mb-0"><i class="fas fa-file-invoice-dollar mr-1"></i>Statement of Values<b-spinner
                  class="ml-2" v-show="isBusy" small label="Small Spinner"></b-spinner></h6>
            </div>
            <div class="card-body p-0">
              <div class="overflow-auto" v-if="details && details.statementOfValues">
                <b-table id="sov-table" :items="details.statementOfValues" :fields="statementOfValueFields">
                  <template v-slot:cell(summary)="data">
                        <div>
                          <span>{{ data.item.locationNumber }}</span>
                          <span>({{ data.item.buildingDescription }})</span>
                        </div>
                        <div class="small text-muted">
                          <span>Building {{data.item.buildingNumber}}</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Yr. {{data.item.yearBuilt}}</span>
                          <span class="text-muted">&bullet;</span>
                          <span>{{data.item.construction}}</span>
                          <span class="text-muted">&bullet;</span>
                          <span>{{data.item.occupancy}}</span>
                        </div>
                        <div class="small text-muted">
                          <span>{{data.item.numberOfUnits}} Units</span>
                          <span class="text-muted">&bullet;</span>
                          <span>{{data.item.numberOfStories}} Stories</span>
                          <span class="text-muted">&bullet;</span>
                          <span>{{data.item.squareFeet}} Sq. Ft</span>
                        </div>                 
                  </template>
                </b-table>
              </div>
              <div class="d-none">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th>Location</th>
                      <th>Rent Control</th>
                      <th class="text-right">Rent Loss $</th>
                      <th class="text-right">PP Coverage</th>
                      <th>Wiring</th>
                      <th>Sprinkler</th>
                      <th>HVAC</th>
                      <th>Plumbing</th>
                      <th>Roof</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div>
                          <span>Loc 101</span>
                          <span>(3 Story Apartments)</span>
                        </div>
                        <div class="small text-muted">
                          <span>Building A1</span>
                          <span class="text-muted">&bullet;</span>
                          <span>1998</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Wood Frame</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Residential</span>
                        </div>
                        <div class="small text-muted">
                          <span>12 Units</span>
                          <span class="text-muted">&bullet;</span>
                          <span>3 Stories</span>
                          <span class="text-muted">&bullet;</span>
                          <span>18000 Sq. Ft</span>
                        </div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div class="text-right">$25,000</div>
                      </td>
                      <td>
                        <div class="text-right">$55,000</div>
                      </td>
                      <td>
                        <div>Copper</div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div>Central</div>
                      </td>
                      <td>
                        <div>PVC</div>
                      </td>
                      <td>
                        <div>Asphalt Shingle</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <span>Loc 101</span>
                          <span>(3 Story Apartments)</span>
                        </div>
                        <div class="small text-muted">
                          <span>Building A1</span>
                          <span class="text-muted">&bullet;</span>
                          <span>1998</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Wood Frame</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Residential</span>
                        </div>
                        <div class="small text-muted">
                          <span>12 Units</span>
                          <span class="text-muted">&bullet;</span>
                          <span>3 Stories</span>
                          <span class="text-muted">&bullet;</span>
                          <span>18000 Sq. Ft</span>
                        </div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div class="text-right">$25,000</div>
                      </td>
                      <td>
                        <div class="text-right">$55,000</div>
                      </td>
                      <td>
                        <div>Copper</div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div>Central</div>
                      </td>
                      <td>
                        <div>PVC</div>
                      </td>
                      <td>
                        <div>Asphalt Shingle</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <span>Loc 102</span>
                          <span>(1 Story Apartments)</span>
                        </div>
                        <div class="small text-muted">
                          <span>Building A1</span>
                          <span class="text-muted">&bullet;</span>
                          <span>1998</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Wood Frame</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Residential</span>
                        </div>
                        <div class="small text-muted">
                          <span>12 Units</span>
                          <span class="text-muted">&bullet;</span>
                          <span>3 Stories</span>
                          <span class="text-muted">&bullet;</span>
                          <span>18000 Sq. Ft</span>
                        </div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div class="text-right">$25,000</div>
                      </td>
                      <td>
                        <div class="text-right">$55,000</div>
                      </td>
                      <td>
                        <div>Copper</div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div>Central</div>
                      </td>
                      <td>
                        <div>PVC</div>
                      </td>
                      <td>
                        <div>Asphalt Shingle</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <span>Loc 103</span>
                          <span>(5 Story Apartments)</span>
                        </div>
                        <div class="small text-muted">
                          <span>Building A1</span>
                          <span class="text-muted">&bullet;</span>
                          <span>1998</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Wood Frame</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Residential</span>
                        </div>
                        <div class="small text-muted">
                          <span>12 Units</span>
                          <span class="text-muted">&bullet;</span>
                          <span>3 Stories</span>
                          <span class="text-muted">&bullet;</span>
                          <span>18000 Sq. Ft</span>
                        </div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div class="text-right">$25,000</div>
                      </td>
                      <td>
                        <div class="text-right">$55,000</div>
                      </td>
                      <td>
                        <div>Copper</div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div>Central</div>
                      </td>
                      <td>
                        <div>PVC</div>
                      </td>
                      <td>
                        <div>Asphalt Shingle</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <span>Loc 104</span>
                          <span>(2 Story Apartments)</span>
                        </div>
                        <div class="small text-muted">
                          <span>Building A1</span>
                          <span class="text-muted">&bullet;</span>
                          <span>1998</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Wood Frame</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Residential</span>
                        </div>
                        <div class="small text-muted">
                          <span>12 Units</span>
                          <span class="text-muted">&bullet;</span>
                          <span>3 Stories</span>
                          <span class="text-muted">&bullet;</span>
                          <span>18000 Sq. Ft</span>
                        </div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div class="text-right">$25,000</div>
                      </td>
                      <td>
                        <div class="text-right">$55,000</div>
                      </td>
                      <td>
                        <div>Copper</div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div>Central</div>
                      </td>
                      <td>
                        <div>PVC</div>
                      </td>
                      <td>
                        <div>Asphalt Shingle</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <span>Loc 105</span>
                          <span>(4 Story Apartments)</span>
                        </div>
                        <div class="small text-muted">
                          <span>Building A1</span>
                          <span class="text-muted">&bullet;</span>
                          <span>1998</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Wood Frame</span>
                          <span class="text-muted">&bullet;</span>
                          <span>Residential</span>
                        </div>
                        <div class="small text-muted">
                          <span>12 Units</span>
                          <span class="text-muted">&bullet;</span>
                          <span>3 Stories</span>
                          <span class="text-muted">&bullet;</span>
                          <span>18000 Sq. Ft</span>
                        </div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div class="text-right">$25,000</div>
                      </td>
                      <td>
                        <div class="text-right">$55,000</div>
                      </td>
                      <td>
                        <div>Copper</div>
                      </td>
                      <td>
                        <div>Yes</div>
                      </td>
                      <td>
                        <div>Central</div>
                      </td>
                      <td>
                        <div>PVC</div>
                      </td>
                      <td>
                        <div>Asphalt Shingle</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import { mapActions } from 'vuex'
  // component code
  export default {
    name: 'PropertyInsurancePolicyDetails',
    data() {
      return {
        isBusy: false,
        policyFields: [
          { key: 'carrierName', label: 'Carrier', sortable: false },
          { key: 'policyType', label: 'Type', sortable: false },
          { key: 'assignmentReason', label: 'Assignment', sortable: false }, // NEW
          { key: 'startDate', label: 'Start', sortable: false },
          { key: 'endDate', label: 'End', sortable: false },
          { key: 'premium', label: 'Premium', sortable: false },
          { key: 'premiumAnnualized', label: 'Prem. Annualized', sortable: false },
          { key: 'coverageAmount', label: 'Coverage', sortable: false },
          { key: 'deductible', label: 'Deductible', sortable: false },
          { key: 'id', label: 'Edit' }
        ],
        //Sample fields - revise property names as needed
        statementOfValueFields: [
          { key: 'summary', label: 'Location', sortable: false },
          // { key: 'locationNumber', label: 'Loc #', sortable: false },
          // { key: 'buildingNumber', label: 'Build #', sortable: false },
          // { key: 'numberOfUnits', label: '# of Units', sortable: false },
          // { key: 'numberOfStories', label: '# of Stories', sortable: false },
          // { key: 'squareFeet', label: 'Sq. Ft.', sortable: false },
          // { key: 'buildingDescription', label: 'Building Description', sortable: false },
          // { key: 'occupancy', label: 'Occupancy', sortable: false },
          // { key: 'yearBuilt', label: 'Year Built', sortable: false },
          // { key: 'construction', label: 'Construction', sortable: false },
          { key: 'rentControlled', label: 'Rent Controlled', sortable: false },
          { key: 'rentLoss', label: 'Rent Loss $', sortable: false },
          { key: 'ppCoverage', label: 'PP Coverage', sortable: false },
          { key: 'wiringType', label: 'Wiring', sortable: false },
          { key: 'sprinklered', label: 'Sprinklers', sortable: false },
          { key: 'hvac', label: 'HVAC', sortable: false },
          { key: 'plumbing', label: 'Plumbing', sortable: false },
          { key: 'roof', label: 'Roof', sortable: false },
          // { key: 'floodZone', label: 'Flood Zone', sortable: false },
          // { key: 'securedEntrance', label: 'Secured Entrance', sortable: false },
          // { key: 'totalInsuranedValue', label: 'TIV', sortable: false },
        ],
        propertyId: null,
        details: null,
      }
    },
    async created() {
      this.propertyId = this.$route.params.id
    },
    async mounted(){
      if(this.propertyId){
        await this.doGetPropertyInsurancePolicyDetails(this.propertyId)
      }
    },
    methods: {
      ...mapActions('company', ['getPropertyInsurancePolicyDetails']),
      async doGetPropertyInsurancePolicyDetails(id) {
        this.isBusy = true
        let result = await this.getPropertyInsurancePolicyDetails(id)
        this.details = result.data.details
        this.isBusy = false

        //Get rid of this code below once result.data.details has a statementOfValues property
        this.details.statementOfValues = [
          { "locationNumber": "Loc 001", "buildingNumber": "A1", "numberOfUnits": 12, "numberOfStories": 3, "squareFeet": 15000, "buildingDescription": "3-story apartment", "occupancy": "Residential", "yearBuilt": 1998, "construction": "Wood Frame", "rentControlled": "Yes", "rentLoss": 25000, "ppCoverage": 50000, "wiringType": "Copper", "sprinklered": "Yes", "hvac": "Central", "plumbing": "PVC", "roof": "Asphalt Shingle", "floodZone": "X", "securedEntrance": "Yes", "totalInsuranedValue": 2000000 },
          { "locationNumber": "Loc 002", "buildingNumber": "B2", "numberOfUnits": 8, "numberOfStories": 2, "squareFeet": 9000, "buildingDescription": "Duplex with parking", "occupancy": "Mixed Use", "yearBuilt": 2005, "construction": "Concrete", "rentControlled": "No", "rentLoss": 15000, "ppCoverage": 30000, "wiringType": "Aluminum", "sprinklered": "No", "hvac": "Split Unit", "plumbing": "Copper", "roof": "Metal", "floodZone": "AE", "securedEntrance": "No", "totalInsuranedValue": 1250000 },
          { "locationNumber": "Loc 003", "buildingNumber": "C3", "numberOfUnits": 20, "numberOfStories": 5, "squareFeet": 30000, "buildingDescription": "Office space", "occupancy": "Commercial", "yearBuilt": 2010, "construction": "Steel Frame", "rentControlled": "No", "rentLoss": 40000, "ppCoverage": 100000, "wiringType": "Copper", "sprinklered": "Yes", "hvac": "Central", "plumbing": "PEX", "roof": "EPDM", "floodZone": "X", "securedEntrance": "Yes", "totalInsuranedValue": 5000000 },
          { "locationNumber": "Loc 004", "buildingNumber": "D4", "numberOfUnits": 6, "numberOfStories": 1, "squareFeet": 4000, "buildingDescription": "Retail store", "occupancy": "Retail", "yearBuilt": 1990, "construction": "Brick", "rentControlled": "No", "rentLoss": 10000, "ppCoverage": 20000, "wiringType": "Copper", "sprinklered": "No", "hvac": "Window Units", "plumbing": "Copper", "roof": "Tar and Gravel", "floodZone": "A", "securedEntrance": "No", "totalInsuranedValue": 750000 },
          { "locationNumber": "Loc 005", "buildingNumber": "E5", "numberOfUnits": 10, "numberOfStories": 4, "squareFeet": 12000, "buildingDescription": "Student housing", "occupancy": "Residential", "yearBuilt": 2018, "construction": "Wood Frame", "rentControlled": "Yes", "rentLoss": 20000, "ppCoverage": 40000, "wiringType": "Copper", "sprinklered": "Yes", "hvac": "Central", "plumbing": "PVC", "roof": "Composite Shingle", "floodZone": "X", "securedEntrance": "Yes", "totalInsuranedValue": 1800000 }
        ]
        //End
      },
    }
  }
  
  </script>
  
<style scoped>

.no-results {
  border: 1px dashed #ccc;
  border-radius: 10px;
  background: #f9f9f9;
}

</style>
  


// WEBPACK FOOTER //
// src/views/policies/PropertyInsurancePolicyDetails.vue